import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { track, setUserProperties } from '@/lib/analytics';
import { setOnboardingStepDone } from '@/lib/storage';
import { OnboardingProgress } from '@/components/OnboardingProgress';
import { Button } from '@/components';
import { FiCreditCard, FiCalendar, FiShield } from 'react-icons/fi';

const TOTAL_STEPS = 11;

const FEATURES = [
  { icon: FiCreditCard, text: 'Log expenses & reimbursements' },
  { icon: FiCalendar, text: 'Organize your custody schedule' },
  { icon: FiShield, text: 'Build a court-ready record' },
];

function SocialProofPage() {
  const navigate = useNavigate();

  useEffect(() => {
    track('Solo Value Screen');
  }, []);

  const handleContinue = () => {
    track('Solo Value Continue Tapped');
    setUserProperties({ onboarding_value_screen: 'solo_value' });
    setOnboardingStepDone('social_proof');
    navigate({ to: '/app/onboarding/goals' });
  };

  return (
    <div className='min-h-screen bg-sky-light flex flex-col'>
      <OnboardingProgress currentStep={2} totalSteps={TOTAL_STEPS} />
      <div className='flex-1 flex flex-col items-center justify-between px-6 max-w-lg mx-auto w-full'>
        <div className='flex-1 flex flex-col items-center justify-center'>
          <h1
            className='text-4xl font-extrabold text-gray-900 text-center leading-tight'
            style={{
              fontFamily:
                "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            }}
          >
            On your own
            <br />
            or together.
          </h1>
          <p
            className='mt-4 text-lg text-gray-500 text-center leading-relaxed'
            style={{
              fontFamily:
                "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            }}
          >
            Log expenses, set your schedule, and build your record. When your co-parent joins,
            everything's already there.
          </p>

          <div className='mt-10 space-y-4'>
            {FEATURES.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className='flex items-center gap-3.5'>
                  <div className='w-12 h-12 rounded-[14px] bg-primary/[0.08] flex items-center justify-center'>
                    <Icon className='w-6 h-6 text-primary' />
                  </div>
                  <span
                    className='text-[17px] font-semibold text-gray-900'
                    style={{
                      fontFamily:
                        "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                    }}
                  >
                    {feature.text}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className='w-full pb-6 pt-4'>
          <Button fullWidth onClick={handleContinue}>
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/app/onboarding/social-proof')({
  component: SocialProofPage,
});
